import React from 'react';

import RECOLETA from '../../../../assets/swiss-medical-center/centro_odontologico_recoleta.jpg';
import Image from '../../../Commons/Image/Image';

import styles from './RecoletaOdontoCenter.module.scss';

const RecoletaOdontoCenter = () => {
  return (
    <div className={styles.recoleta_odonto_center}>
      <h3>Swiss Medical Center Recoleta</h3>
      <p>
        <strong className={styles.recoleta_odonto_center__redText}>Dirección: </strong>Junín 1191
        (1113), Capital Federal
      </p>
      <p>
        <strong className={styles.recoleta_odonto_center__redText}>Turnos: </strong>0810-333-8876
      </p>
      <Image
        src={RECOLETA}
        alt='Center Recoleta'
        title='Swiss Medical Center Recoleta'
        classes={styles.recoleta_odonto_center__image}
      />
      <ul>
        <li>Odontología General</li>
        <li>Endodoncia</li>
        <li>Periodoncia</li>
        <li>Radiografías: periapical-Seriada media y completa</li>
        <li>Radiografías: Bite Wing, oclusal y panoramica</li>
        <li>Teleradiografía</li>
        <li>Estudios cefalométrios: Ricketts-B. Jarabak-Steiner-Schwarz-Mc Namara</li>
        <li>Tomografía lineal</li>
        <li>Prótesis dentales</li>
      </ul>
      <p>
        <strong className={styles.recoleta_odonto_center__redText}>
          Días y horarios de atención
        </strong>
      </p>
      <p>Lunes a Viernes | 08 hs. a 20 hs.</p>
      <p>Sábados | 08 hs. a 14 hs.</p>
    </div>
  );
};

export default RecoletaOdontoCenter;
